var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82251 -0.000508308C8.17139 0.00150013 8.5159 0.0755739 8.83349 0.216863C9.17697 0.364978 9.46961 0.606685 9.67646 0.913117C9.88331 1.21955 9.99563 1.57776 10 1.94495L10 11.0962C9.99563 11.4634 9.88331 11.8216 9.67646 12.1281C9.46961 12.4345 9.17697 12.6762 8.83349 12.8243C8.43827 13.007 7.99856 13.0773 7.56447 13.0273C7.13037 12.9774 6.71935 12.8091 6.37825 12.5417L0.712329 7.96611C0.490142 7.79306 0.310708 7.57323 0.187379 7.32296C0.0640497 7.07269 0 6.79843 0 6.5206C0 6.24276 0.0640497 5.9685 0.187379 5.71824C0.310708 5.46797 0.490142 5.24813 0.712329 5.07508L6.37825 0.499441C6.78667 0.175424 7.29668 -0.00112343 7.82251 -0.000508308Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftMenu);
export default __webpack_public_path__ + "static/media/leftMenu.53410410272211f8141a2eda92e3171e.svg";
export { ForwardRef as ReactComponent };